module.exports = __webpack_public_path__ + "img/scene_romance_backlight@2x.de2c7892.png";